export default __webpack_public_path__ + "img/c5e206fbe2a9e7f953110ad5b42c1d0e.png";